var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { editTaskRequest } from "../../../api/api";
import { CLOSE_TASK_MODAL, PIPELINE_EDIT_TASK } from "../../../constants";
import { useTaskActions } from "../../../hooks/actions/useTaskActions";
import { DispatchType, useModal } from "../../../hooks/useModal";
import { ModalContext } from "../../../providers/ModalContextProvider";
import { WPQTModal } from "../WPQTModal";
import { TaskModalContent } from "./TaskModalContent";
function TaskModal({ editTaskCallback, deleteTaskCallback }) {
    const { state: { taskModalOpen }, } = useContext(ModalContext);
    const { deleteTask } = useTaskActions();
    const { modalSaving, setModalSaving, modalContentRef, closeModal, handleSuccess, handleError, } = useModal(CLOSE_TASK_MODAL);
    const editTask = (task) => __awaiter(this, void 0, void 0, function* () {
        try {
            setModalSaving(true);
            const response = yield editTaskRequest(task);
            handleSuccess(PIPELINE_EDIT_TASK, response.data, DispatchType.ACTIVE_PIPELINE);
            if (editTaskCallback) {
                editTaskCallback(response.data);
            }
        }
        catch (error) {
            handleError(error);
        }
    });
    const onDeleteTask = (task) => __awaiter(this, void 0, void 0, function* () {
        deleteTask(task.id, () => {
            if (deleteTaskCallback) {
                deleteTaskCallback(task);
            }
        });
    });
    return (_jsx(WPQTModal, { modalOpen: taskModalOpen, closeModal: closeModal, size: "xl", children: _jsx(TaskModalContent, { ref: modalContentRef, editTask: editTask, deleteTask: onDeleteTask, taskModalSaving: modalSaving }) }));
}
export { TaskModal };
